/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Premium Diesel`
};

const en_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Diesel Premium`
};

const es_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Diésel premium`
};

const fr_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Gazole Premium`
};

const it_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Diesel premium`
};

const nl_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Premium diesel`
};

const pt_gas_station__fuel_label__b101 = /** @type {(inputs: {}) => string} */ () => {
	return `Gasóleo Premium`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const gas_station__fuel_label__b101 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gas_station__fuel_label__b101(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("gas_station__fuel_label__b101", locale)
	if (locale === "de") return de_gas_station__fuel_label__b101(inputs)
	if (locale === "en") return en_gas_station__fuel_label__b101(inputs)
	if (locale === "es") return es_gas_station__fuel_label__b101(inputs)
	if (locale === "fr") return fr_gas_station__fuel_label__b101(inputs)
	if (locale === "it") return it_gas_station__fuel_label__b101(inputs)
	if (locale === "nl") return nl_gas_station__fuel_label__b101(inputs)
	return pt_gas_station__fuel_label__b101(inputs)
};
export { gas_station__fuel_label__b101 as "gas_station__fuel_label__B10" }